import { jsxs, Fragment, jsx } from "react/jsx-runtime";
import { useState, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useColors, useResponsive } from "@inbody/core";
import PersonSearchOutlinedIcon from "@mui/icons-material/PersonSearchOutlined";
import Stack from "@mui/material/Stack";
import { HeaderIconButton } from "../header/components/HeaderIconButton.js";
import { UserSearchBar } from "./components/UserSearchBar.js";
import { UserSearchDetail } from "./components/UserSearchDetail.js";
import { UserSearchResultList } from "./components/UserSearchResultList.js";
import { useUserSearch } from "./hooks/useUserSearch.js";
import { ModalBase } from "../modal-base/ModalBase.js";
function UserSearch(props = {}) {
  const { getOrgGroupHref, onSelectOrgGroup } = props;
  const { t } = useTranslation("ui");
  const { gray } = useColors();
  const [open, setOpen] = useState(false);
  const handleOpenModal = useCallback(() => {
    setOpen(true);
  }, []);
  const handleCloseModal = useCallback(() => {
    setOpen(false);
  }, []);
  const {
    query,
    setQuery,
    onClearQuery,
    filteredUserList,
    selectedUserId,
    selectedUser,
    onSelectUser
  } = useUserSearch();
  const { isMobile } = useResponsive();
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(HeaderIconButton, { onClick: handleOpenModal, "aria-label": "user search", children: /* @__PURE__ */ jsx(PersonSearchOutlinedIcon, { fontSize: isMobile ? "small" : "medium" }) }),
    /* @__PURE__ */ jsx(
      ModalBase,
      {
        open,
        onClose: handleCloseModal,
        title: t("임직원 검색"),
        subtitle: isMobile ? t("결과를 고르면 아래에 전체 정보가 표시됩니다") : t("결과를 고르면 오른쪽에 전체 정보가 표시됩니다"),
        maxWidth: "laptop",
        fullScreenOnMobile: true,
        children: /* @__PURE__ */ jsxs(Stack, { spacing: 2, children: [
          /* @__PURE__ */ jsx(
            UserSearchBar,
            {
              query,
              onQueryChange: setQuery,
              onClearQuery
            }
          ),
          /* @__PURE__ */ jsxs(
            Stack,
            {
              direction: { mobile: "column", tablet: "row" },
              spacing: 2.5,
              sx: {
                // 좌우로 나란한 폭에서는 두 칸이 같은 높이를 갖고 각자 스크롤한다.
                // 세로로 쌓이는 좁은 폭에서는 높이를 풀어 목록·상세가 차례로 흐르게 두고,
                // 대신 목록 쪽에만 높이 상한을 걸어 상세가 화면 밖으로 밀리지 않게 한다.
                height: { mobile: "auto", tablet: "60vh" },
                minHeight: 0
              },
              children: [
                /* @__PURE__ */ jsx(
                  UserSearchResultList,
                  {
                    filteredUserList,
                    selectedUserId,
                    onSelectUser
                  }
                ),
                /* @__PURE__ */ jsx(
                  Stack,
                  {
                    flex: "1 1 auto",
                    minHeight: 0,
                    minWidth: 0,
                    sx: {
                      borderTop: {
                        mobile: `1px solid ${gray[100]}`,
                        tablet: "none"
                      },
                      pt: { mobile: 2, tablet: 0 }
                    },
                    children: /* @__PURE__ */ jsx(
                      UserSearchDetail,
                      {
                        user: selectedUser,
                        getOrgGroupHref,
                        onSelectOrgGroup
                      }
                    )
                  }
                )
              ]
            }
          )
        ] })
      }
    )
  ] });
}
export {
  UserSearch
};
